/**
 * Currency Formatting Utilities
 */

/**
 * Format price in cents to USD currency string
 * @param cents - Price in cents (e.g., 2999)
 * @returns Formatted currency string (e.g., "$29.99")
 */
export function formatPrice(cents: number): string {
  const dollars = cents / 100;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(dollars);
}

/**
 * Format price in cents to USD without symbol
 * @param cents - Price in cents (e.g., 2999)
 * @returns Formatted number string (e.g., "29.99")
 */
export function formatPriceWithoutSymbol(cents: number): string {
  const dollars = cents / 100;
  return dollars.toFixed(2);
}

/**
 * Parse price string to cents
 * @param priceString - Price string (e.g., "$29.99" or "29.99")
 * @returns Price in cents (e.g., 2999)
 */
export function parsePriceToCents(priceString: string): number {
  const cleanedPrice = priceString.replace(/[^0-9.]/g, '');
  const dollars = parseFloat(cleanedPrice);
  return Math.round(dollars * 100);
}
